import { useContext, createContext } from 'react';
import noop from 'utils/noop';

export type CollapseState = {
  toggle: (key: string) => void;
  isCollapsed: (key: string) => boolean;
};

export const CollapseStateContext = createContext<CollapseState>({
  toggle: noop,
  isCollapsed: () => false,
});

export const useCollapseStateContext = () => useContext(CollapseStateContext);
